module.exports = __webpack_public_path__ + "assets/img/tx106.d590ecf5.jpg";